<template>
  <div>
    <b-card title="Görsel">
      <b-img
        v-if="itemData.image"
        :src="imageUrl + '/media/about/' + itemData.image"
        thumbnail
        center
      />
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          @click="setModal('about')"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </b-card>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      :width-size="cropperSettings.widthSize"
      component="about"
      :params="cropperSettings.type"
      :item-id="itemData.id"
      @uploadImage="setUploadImage"
    />
  </div>
</template>

<script>
import { BButton, BCard, BImg } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'

export default {
  name: 'ImageCard',
  components: {
    CropperImage, BCard, BButton, BImg,
  },
  data() {
    return {
      imageUrl: this.$store.state.app.baseURL,
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
  methods: {
    setModal(type) {
      if (type === 'about') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'about-image.jpg',
          folder: 'about',
          ratio: null,
          widthSize: 1200,
          type: 'about',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'about') {
        this.itemData.image = item.filename
        this.itemData.thumb = item.thumb
        this.itemData.image_webp = item.filename_webp
        this.itemData.thumb_webp = item.thumb_webp
        this.itemData.mediaData = item
      }
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
